/*
 * @Author: Pluto 66291979@qq.com
 * @Date: 2024-05-31 11:37:41
 * @LastEditors: pluto.guo 66291979@qq.com
 * @LastEditTime: 2025-01-03 15:34:12
 * @FilePath: /lobby/src/stores/eventdeposit.js
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import { defineStore } from 'pinia'
import { useUserStore } from '@/stores/user.js'
import { post } from '@/common/request'
import { url } from '@/common/config'

export const useEventDepositStore = defineStore('eventdeposit', {
  state: () => {
    return {}
  },
  getters: {
    country() {
      return useUserStore().country
    }
  },
  actions: {
    /**
     * 发送请求以领取限时充值奖励。
     *
     * @returns 
    ```json
      {
          "code": "string",
          "data": {
            "bonusAmount": 0,
            "result": true
          },
          "message": "string",
          "success": true
      }
    ```
     */
    claim() {
      // 使用 post 函数发送 POST 请求到指定的 URL，该 URL 是用于领取限时充值奖励的。
      return post(url.event.limited.time.recharge.claim)
    },
    /**
     * 获取限时充值活动的配置信息。
     ** @returns 
    ```json
      {
        "code": "string",
        "data": {
          "bonusAmount": 0,
          "coolDown": 0,
          "currentRecharge": 0,
          "eventStatus": true,
          "needRecharge": 0,
          "userStatus": 0
        },
        "message": "string",
        "success": true
      }
    ```
     */
    getConfig() {
      return post(url.event.limited.time.recharge.get, {
        country: this.country
      })
    }
  }
})
